import React from "react";
import {LoadingBackdrop} from "@/components/Layout/DefaultLayout";

const Dashboard = React.lazy(() => import('@/features/Dashboard'))

export default function Home() {
    return (
        <React.Suspense fallback={<LoadingBackdrop/>}>
            <Dashboard/>
        </React.Suspense>
    )
}